import { render } from "./zhuboItem.vue?vue&type=template&id=b88c7fd4&scoped=true"
import script from "./zhuboItem.vue?vue&type=script&lang=js"
export * from "./zhuboItem.vue?vue&type=script&lang=js"

import "./zhuboItem.vue?vue&type=style&index=0&id=b88c7fd4&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\宽版\\shancgai2-修改农业-审计修改\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b88c7fd4"]])

export default __exports__